import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';

const DEFAULT_DELAY_MS = 120;

export const delayGuard: CanActivateFn = async (route: ActivatedRouteSnapshot): Promise<boolean> => {
  const queryDelay = route.queryParams.delay || null;
  const ms = queryDelay ? Number(queryDelay) : DEFAULT_DELAY_MS;
  await new Promise((resolve) => setTimeout(resolve, ms));
  return true;
};
